import * as tslib_1 from "tslib";
import * as lazyTriageActions from 'owa-mail-triage-action';
import * as markReadActions from 'owa-mail-mark-read-actions';
import createScheduleSubMenu from 'owa-mail-list-context-menu/lib/helpers/createScheduleSubMenu';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import isReadingPaneBottom from 'owa-mail-reading-pane-store/lib/utils/isReadingPaneBottom';
import strings from 'owa-strings/owa-mail-strings';
import { FilterableMenuItem } from 'owa-filterable-menu';
import { getCategoryMenuPropertiesForContextMenu } from 'owa-mail-category-view';
import { getMoveToPropertiesForContextMenu } from 'owa-mail-movetofolder-view';
import { lazyMoveReadingPaneToTab } from 'owa-mail-reading-pane-store';
import { lazyShowInboxRuleDialog } from 'owa-mail-rule-view';
import { listViewStore, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { showInImmersiveReader } from 'owa-immersive-reader-store';
import { getMailMenuItemShouldShowMap, getMailMenuItemShouldDisable, } from 'owa-mail-filterable-menu-behavior';
import { lazyForwardConversation, lazyReplyToConversation, lazyForwardItem, lazyReplyToItem, lazyShowConversationInImmersiveReader, } from 'owa-mail-message-actions';
// Used as a key for divider, because IContextualMenuItem requires each element to have a different key
var dividerKey = 0;
/**
 * Get an array of filterable menu items for mail list context menu
 * @param rowKeys the row keys to show the context menu
 * @param tableViewId the id of the table that contains these rows
 * @return the context menu items
 */
export default function getFilterableMailListContextMenuItems(rowKeys, tableViewId, onDismiss) {
    var shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
    return [
        // Reply/Reply all/Forward
        new FilterableMenuItem(strings.itemHeaderReply, null /* icon */, function () { return onReplyRow(rowKeys[0], tableViewId); }, shouldShowBehaviorMap[24 /* Reply */]),
        new FilterableMenuItem(strings.itemHeaderReplyAll, null /* icon */, function () { return onReplyAllRow(rowKeys[0], tableViewId); }, shouldShowBehaviorMap[25 /* ReplyAllForward */]),
        new FilterableMenuItem(strings.itemHeaderForward, null /* icon */, function () { return onForwardRow(rowKeys[0], tableViewId); }, shouldShowBehaviorMap[25 /* ReplyAllForward */]),
        newDivider(function () {
            return (shouldShowBehaviorMap[16 /* Move */]() ||
                shouldShowBehaviorMap[6 /* Delete */]() ||
                shouldShowBehaviorMap[27 /* Restore */]() ||
                shouldShowBehaviorMap[2 /* Archive */]() ||
                shouldShowBehaviorMap[7 /* EmptyFolder */]() ||
                shouldShowBehaviorMap[4 /* Categories */]());
        }),
        // Delete/Restore/Archive
        new FilterableMenuItem(strings.deleteItem, null /* icon */, function () { return onDeleteClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[6 /* Delete */], null /* display */, getMailMenuItemShouldDisable(6 /* Delete */)),
        new FilterableMenuItem(strings.restoreItem, null /* icon */, function () {
            return lazyTriageActions.lazyRestoreMailListRowsAction.importAndExecute(rowKeys, tableViewId);
        }, shouldShowBehaviorMap[27 /* Restore */]),
        new FilterableMenuItem(strings.archive, null /* icon */, function () { return onArchiveClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[2 /* Archive */]),
        new FilterableMenuItem(strings.move, null, // no - icon
        function () { }, shouldShowBehaviorMap[16 /* Move */], null /* displayOption*/, false /* disabled */, getMoveToPropertiesForContextMenu(tableViewId, onDismiss, 'ContextLV', shouldShowBehaviorMap)),
        new FilterableMenuItem(strings.categoryMenuItemMenuText, null, // no - icon
        function () { }, shouldShowBehaviorMap[4 /* Categories */], null /* displayOption*/, false /* disabled */, getCategoryMenuPropertiesForContextMenu(tableViewId, onDismiss, 'ContextLV')),
        // Empty folder
        new FilterableMenuItem(strings.deleteItem, null /* icon */, function () {
            var tableView = listViewStore.tableViews.get(tableViewId);
            lazyTriageActions.lazyEmptyTableView.importAndExecute(tableView, false /*isExplicitSoftDelete*/, 'ContextLV', tableView.virutalSelectAllExclusionList);
        }, shouldShowBehaviorMap[7 /* EmptyFolder */]),
        newDivider(function () {
            return (shouldShowBehaviorMap[14 /* MarkAsRead */]() ||
                shouldShowBehaviorMap[15 /* MarkAsUnread */]() ||
                shouldShowBehaviorMap[8 /* Flag */]() ||
                shouldShowBehaviorMap[36 /* Unflag */]() ||
                shouldShowBehaviorMap[22 /* Pin */]() ||
                shouldShowBehaviorMap[37 /* Unpin */]());
        }),
        // Mark as read/unread
        new FilterableMenuItem(strings.markAsRead, null /* icon */, function () { return onMarkAsReadClicked(tableViewId); }, shouldShowBehaviorMap[14 /* MarkAsRead */]),
        new FilterableMenuItem(strings.markAsUnread, null /* icon */, function () { return onMarkAsUnreadClicked(tableViewId); }, shouldShowBehaviorMap[15 /* MarkAsUnread */]),
        // Schedule/Unschedule
        new FilterableMenuItem('Schedule', null, // no - icon
        function () { }, shouldShowBehaviorMap[30 /* Schedule */], null /* displayOption*/, false /* disabled */, createScheduleSubMenu(rowKeys, tableViewId, 'ContextLV' /* actionSource */)),
        // Flag/Unflag
        new FilterableMenuItem(strings.flag, null /* icon */, function () { return markRowsAsFlagged(rowKeys, tableViewId); }, shouldShowBehaviorMap[8 /* Flag */]),
        new FilterableMenuItem(strings.unflag, null /* icon */, function () { return markRowsAsNotFlagged(rowKeys, tableViewId); }, shouldShowBehaviorMap[36 /* Unflag */]),
        // Pin/unpin
        new FilterableMenuItem(strings.pin, null /* icon */, function () { return markRowsPinnedUnpinned(rowKeys, tableViewId, true /* shouldMarkAsPinned */); }, shouldShowBehaviorMap[22 /* Pin */]),
        new FilterableMenuItem(strings.unpin, null /* icon */, function () { return markRowsPinnedUnpinned(rowKeys, tableViewId, false /* shouldMarkAsPinned */); }, shouldShowBehaviorMap[37 /* Unpin */]),
        newDivider(function () {
            return (shouldShowBehaviorMap[12 /* MarkAsJunk */]() ||
                shouldShowBehaviorMap[13 /* MarkAsNotJunk */]() ||
                shouldShowBehaviorMap[9 /* Ignore */]() ||
                shouldShowBehaviorMap[33 /* StopIgnoring */]() ||
                shouldShowBehaviorMap[3 /* Block */]());
        }),
        // Junk/Not junk/Block
        new FilterableMenuItem(strings.markAsJunk, null /* icon */, function () { return onJunkNotJunkClicked(rowKeys, tableViewId, true /* isJunkValueToSet */); }, shouldShowBehaviorMap[12 /* MarkAsJunk */]),
        new FilterableMenuItem(strings.markAsNotJunk, null /* icon */, function () { return onJunkNotJunkClicked(rowKeys, tableViewId, false /* isJunkValueToSet */); }, shouldShowBehaviorMap[13 /* MarkAsNotJunk */]),
        new FilterableMenuItem(strings.ignore, null /* icon */, function () { return onIgnoreStopIgnoreClicked(rowKeys, tableViewId, true); }, shouldShowBehaviorMap[9 /* Ignore */]),
        new FilterableMenuItem(strings.stopIgnoring, null /* icon */, function () { return onIgnoreStopIgnoreClicked(rowKeys, tableViewId, false); }, shouldShowBehaviorMap[33 /* StopIgnoring */]),
        new FilterableMenuItem(strings.block, null /* icon */, function () { return onBlockClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[3 /* Block */]),
        newDivider(function () {
            return (shouldShowBehaviorMap[10 /* InboxRule */]() ||
                shouldShowBehaviorMap[29 /* Translate */]() ||
                shouldShowBehaviorMap[31 /* ShowInImmersiveReader */]());
        }),
        new FilterableMenuItem(strings.createRule, null, // no - icon
        function () { return onCreateRuleClicked(rowKeys[0], tableViewId); }, shouldShowBehaviorMap[10 /* InboxRule */], null /* displayOption */),
        // Translate
        new FilterableMenuItem(strings.itemHeaderTranslate, null, // no - icon
        function () { return onTranslateClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[29 /* Translate */]),
        // Show in immersive reader
        new FilterableMenuItem(strings.showInImmersiveReader, null, // no - icon
        function () {
            onShowInImmersiveReaderClicked(rowKeys[0], tableViewId);
        }, shouldShowBehaviorMap[31 /* ShowInImmersiveReader */]),
        new FilterableMenuItem(strings.openInNewTab, null, // no - icon
        function () { return onOpenInNewTabClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[20 /* OpenInNewTab */]),
    ];
}
/**
 * Called when user clicks on the reply menu item
 * @param rowKey the row key
 * @param tableViewId the table view id
 */
function onReplyRow(rowKey, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    var instrumentationContexts;
    if (tableView.tableQuery.type == 1 /* Search */) {
        instrumentationContexts = getInstrumentationContextsFromTableView([rowKey], tableView);
    }
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            lazyReplyToConversation.importAndExecute(rowId, false /*isReplyAll*/, 'ContextLV', instrumentationContexts, isReadingPaneBottom() /*isFullCompose*/);
            break;
        case 1 /* Message */:
            lazyReplyToItem.importAndExecute(rowId, false /* isReplyAll */, instrumentationContexts, 'ContextLV');
    }
}
/**
 * Called when user clicks on the reply all menu item
 * @param rowKey the row key
 * @param tableViewId the table view id
 */
function onReplyAllRow(rowKey, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    var instrumentationContexts;
    if (tableView.tableQuery.type == 1 /* Search */) {
        instrumentationContexts = getInstrumentationContextsFromTableView([rowKey], tableView);
    }
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            lazyReplyToConversation.importAndExecute(rowId, true /*isReplyAll*/, 'ContextLV', instrumentationContexts, isReadingPaneBottom() /*isFullCompose*/);
            break;
        case 1 /* Message */:
            lazyReplyToItem.importAndExecute(rowId, true /* isReplyAll */, instrumentationContexts, 'ContextLV');
    }
}
/**
 * Called when user clicks on the forward menu item
 * @param rowKey the row key
 * @param tableViewId the table view id
 */
function onForwardRow(rowKey, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    var instrumentationContexts;
    if (tableView.tableQuery.type == 1 /* Search */) {
        instrumentationContexts = getInstrumentationContextsFromTableView([rowKey], tableView);
    }
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            lazyForwardConversation.importAndExecute(rowId, 'ContextLV', instrumentationContexts);
            break;
        case 1 /* Message */:
            lazyForwardItem.importAndExecute(rowId, 'ContextLV', instrumentationContexts);
            break;
    }
}
/**
 * Create a divider which is used in the mail list context menu
 * @param shouldShow the should show behavior which indicates whether to show the context menu or not
 */
function newDivider(shouldShowBehavior) {
    return new FilterableMenuItem('-' /* name */, null /* icon */, null /* onClick */, shouldShowBehavior, null /* displayOption */, null /* disabled*/, null /* menuContent */, (dividerKey++).toString());
}
/**
 * Called when user clicks on the delete menu item
 */
function onDeleteClicked(rowKeys, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    if (tableView.isInVirtualSelectAllMode) {
        // When in virtual selection, i.e non search and select all mode,
        // delete all in the folder
        lazyTriageActions.lazyEmptyTableView.importAndExecute(tableView, false /*isExplicitSoftDelete*/, 'ContextLV', tableView.virutalSelectAllExclusionList);
    }
    else {
        lazyTriageActions.lazyDeleteMailListRows.importAndExecute(rowKeys, tableViewId, false /*isExplicitSoftDelete*/, 'ContextLV');
    }
}
/**
 * Called when user clicks on the archive menu item
 */
function onArchiveClicked(rowKeys, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    lazyTriageActions.lazyArchiveMailListRows.importAndExecute(rowKeys, tableView, 'ContextLV');
}
/**
 * Called when the user clicks on the "Show in immersive reader" menu item
 */
function onShowInImmersiveReaderClicked(rowKey, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            lazyShowConversationInImmersiveReader.importAndExecute(rowId /* conversationId */);
            break;
        case 1 /* Message */:
            showInImmersiveReader(rowId /* itemId */);
            break;
    }
}
/**
 * Called when the user clicks on the "Open in new tab" menu item
 */
function onOpenInNewTabClicked(rowKeys, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var instrumentationContexts = getInstrumentationContextsFromTableView(rowKeys, tableView);
    for (var i = 0; i < rowKeys.length; i++) {
        var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKeys[i], tableView);
        var rowSubject = MailRowDataPropertyGetter.getSubject(rowKeys[i], tableView);
        var rowCategories = MailRowDataPropertyGetter.getCategories(rowKeys[i], tableView);
        lazyMoveReadingPaneToTab.importAndExecute(rowId, rowSubject, rowCategories, true /*makeActive*/, instrumentationContexts[i]);
    }
}
function onMarkAsReadClicked(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    markReadActions.lazyMarkAsReadInTable.importAndExecute('ContextLV', tableView.virutalSelectAllExclusionList /* exclusionList */, tableView.isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, true /* isReadValueToSet */, tableView.selectedRowKeys.keys() /* rowKeysToActOn */, tableView);
}
function onMarkAsUnreadClicked(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    markReadActions.lazyMarkAsReadInTable.importAndExecute('ContextLV', tableView.virutalSelectAllExclusionList, tableView.isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, false /* isReadValueToSet */, tableView.selectedRowKeys.keys(), tableView);
}
function onBlockClicked(rowKeys, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    lazyTriageActions.lazyBlockLastSendersFromTable.importAndExecute(rowKeys, tableView, 'ContextLV');
}
function markRowsAsFlagged(rowKeys, tableViewId) {
    lazyTriageActions.lazySetMailListRowsFlagState.importAndExecute(rowKeys, tableViewId, 'Flagged');
}
function markRowsAsNotFlagged(rowKeys, tableViewId) {
    lazyTriageActions.lazySetMailListRowsFlagState.importAndExecute(rowKeys, tableViewId, 'NotFlagged');
}
function onJunkNotJunkClicked(rowKeys, tableViewId, isJunkValueToSet) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    lazyTriageActions.lazyMarkRowsJunkNotJunk.importAndExecute(rowKeys, tableView, isJunkValueToSet, 'ContextLV' /* actionSource */);
}
function onIgnoreStopIgnoreClicked(rowKeys, tableViewId, shouldIgnore) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var toggleIgnoreConversations;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyTriageActions.lazyToggleIgnoreConversations.import()];
                case 1:
                    toggleIgnoreConversations = _a.sent();
                    toggleIgnoreConversations(rowKeys, tableViewId, shouldIgnore, 'ContextLV');
                    return [2 /*return*/];
            }
        });
    });
}
function markRowsPinnedUnpinned(rowKeys, tableViewId, shouldMarkAsPinned) {
    lazyTriageActions.lazyMarkRowsPinnedUnpinned.importAndExecute(rowKeys, tableViewId, shouldMarkAsPinned, 'ContextLV');
}
/**
 * Called when user clicks on the create rule menu item
 */
function onCreateRuleClicked(rowKey, tableViewId) {
    // Get the sender from the single selected conversation.
    // Ensuring a single selection and that the selection
    // has an SMTP address is handled in the context menu should show behavior map
    var sender = MailRowDataPropertyGetter.getLastSenderMailbox(rowKey, listViewStore.tableViews.get(tableViewId));
    lazyShowInboxRuleDialog.importAndExecute(sender, 'ContextLV');
}
/**
 * Called when the user clicks on the "Translate" menu item
 */
function onTranslateClicked(rowKeys, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    lazyTriageActions.lazyTranslateFromTable.importAndExecute(rowKeys, tableView, 'ContextLV');
}
//# sourceMappingURL=getFilterableMailListContextMenuItems.js.map